import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import LeadCaptureHistory from './LeadCaptureHistory.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/pilot'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'PILOT_SETTINGS.TITLE',
        icon: 'i-lucide-rocket',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'pilot_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'lead-capture-history',
          name: 'pilot_lead_capture_history_index',
          component: LeadCaptureHistory,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
